<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sigil_not_in_toc" id="pgepubid00000">LITTLE MISS MOUSE</h1>
<p class="calibre3"><br class="calibre4"/>
<br class="calibre4"/>
</p>
<p class="t">
BY<br class="calibre4"/>
</p>
<p class="t1">AMY E. BLANCHARD<br class="calibre5"/>
<br class="calibre5"/>
</p>
<p class="t">
Author of "Little Maid Marian," "Little Miss Oddity,"<br class="calibre4"/>
"Little Sister Anne," "Mistress May," etc.<br class="calibre4"/>
<br class="calibre4"/>
</p>
<p class="calibre3"><br class="calibre4"/>
<br class="calibre4"/>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section00_0001.vue?2171cc36